export default __webpack_public_path__ + "static/media/off-30.bd0de057.png";